import React, { useState } from "react";
import { Box, MenuItem, TextField } from "@mui/material";
import { useField } from "formik";

// Seed limits are saved in kg; the display unit never changes their meaning.
export function LowStockLotField({
  seed,
  defaultUnit = "kg",
}: {
  seed: boolean;
  defaultUnit?: "kg" | "lb";
}) {
  const [unit, setUnit] = useState(defaultUnit);
  const [field, meta, helpers] = useField<number | null>({
    name: "lowStockThreshold",
    validate: (value) =>
      value != null &&
      (!Number.isFinite(value) ||
        value < 0 ||
        (!seed && !Number.isSafeInteger(value)))
        ? "Enter a non-negative limit; packaging requires a whole count."
        : undefined,
  });
  const factor = seed && unit === "lb" ? 0.45359237 : 1;
  return (
    <Box sx={{ display: "flex", gap: 2, my: 2 }}>
      <TextField
        fullWidth
        label={seed ? "Low-stock weight limit" : "Low-stock count limit"}
        type="number"
        value={
          field.value == null
            ? ""
            : Number((field.value / factor).toPrecision(12))
        }
        onChange={(event) =>
          helpers.setValue(
            event.target.value === ""
              ? null
              : Number(event.target.value) * factor,
          )
        }
        onBlur={() => helpers.setTouched(true)}
        inputProps={{ min: 0, step: seed ? "any" : 1 }}
        error={!!meta.error}
        helperText={
          meta.error ||
          "This lot only. Leave blank to disable; 0 warns when empty."
        }
      />
      {seed && (
        <TextField
          select
          label="Limit unit"
          value={unit}
          onChange={(event) => setUnit(event.target.value as "kg" | "lb")}
          sx={{ minWidth: 100 }}
        >
          <MenuItem value="kg">kg</MenuItem>
          <MenuItem value="lb">lb</MenuItem>
        </TextField>
      )}
    </Box>
  );
}
